import { observable } from "mobx";
import { Type } from "class-transformer";
import type { EntityValidationRules } from "services/validationService";
import { subDays } from "date-fns";
import { endOfCzechDay, startOfCzechDay } from "../utils/dateUtils";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class LustrationReportCreateRequest {
  @observable
  licensePlate!: string;

  @observable
  countryId!: string;

  @observable
  @Type(() => Date)
  eventOccurredAt!: Date;

  @observable
  @Type(() => Date)
  _eventOccurredAtDate!: Date;

  @observable
  _eventOccurredAtTime: string;

  @observable
  forceRequest?: boolean;
}

export const LustrationReportCreateValidationRules: EntityValidationRules<LustrationReportCreateRequest> = {
  licensePlate: {
    required: true,
    isLicensePlate: true,
  },
  countryId: {
    required: true,
  },
  _eventOccurredAtDate: {
    required: true,
    isAfter: {
      condition: (entity: LustrationReportCreateRequest) => startOfCzechDay(subDays(new Date(), 732)),
      customMessage: "afterOccurredDate",
    },
    isBefore: {
      condition: (entity: LustrationReportCreateRequest) => endOfCzechDay(new Date()),
      customMessage: "beforeFutureOccurredDate",
    },
  },
  _eventOccurredAtTime: {
    required: true,
  },
};
